module.exports = __webpack_public_path__ + "static/media/29EUNOG12.c7294199.jpg";